<template>
  <div class="page-firm-lawyer-search main-page">
    <Menus title="律师律所" />
    <div class="container-flex">
      <div class="firm-lawyer-content  ">

        <div class="tab-nav flex text-lg pt-5">
          <router-link to="/flsearch/1" replace :class="['nav-item',{'active':curType==1}]">律师</router-link>
          <router-link to="/flsearch/2" replace :class="['nav-item',{'active':curType==2}]">律师事务所</router-link>
        </div>
        <div :class="['input-panel  ',`c${curType}`]">
          <input type="text" v-if="curType==1" @focus="setTxtArea" v-model="searchForm.mc" placeholder="请输入律师中文名/执业证号">
          <input type="text" v-if="curType==2" @focus="setTxtArea" v-model="searchForm.zwmc" placeholder="请输入律师事务所中文名/统一社会信用代码">
          <button @click="getSearch"> <img src="https://qiniu.laway.cn/yn/2025/02/08/f8648f40e5c411ef99f8b4055d0b07be.svg"> 搜索</button>
        </div>
        <div class="search-params  ">
          <div class="hts">高级检索</div>
          <div class="params-item">
            <div class="params-item-title">所在地区：</div>
            <div class="params-item-content">
              <div @click="searchForm.city=''" :class="['radio-item  ',{active:!searchForm.city}]">
                <input type="radio">
                不限
              </div>
              <div @click="searchForm.city = key" :class="['radio-item  ',{active:searchForm.city==key}]" v-for="(city, key) in arealist" :key="'key-c' + key">
                <input type="radio" v-model="searchForm.code">
                {{city.alias}}
              </div>
            </div>
          </div>
          <div class="params-item" v-if="arealist[searchForm.city]">
            <div class="params-item-title">所在区县：</div>
            <div class="params-item-content">
              <div @click="searchForm.code=''" :class="['radio-item  ',{active:!searchForm.code}]">
                <input type="radio" v-model="searchForm.code">
                不限
              </div>
              <div @click="searchForm.code = key" :class="['radio-item  ',{active:searchForm.code==key}]" v-for="(v, key) in arealist[searchForm.city].children" :key="'key-c' + key">
                <input type="radio" v-model="searchForm.code">
                {{v.alias}}
              </div>
            </div>
          </div>
          <div class="params-item" v-if="curType==1">
            <div class="params-item-title">性别：</div>
            <div class="params-item-content">
              <div @click="searchForm.xb=''" :class="['radio-item ',{active:!searchForm.xb}]">
                <input type="radio" value="">
                不限
              </div>
              <div @click="searchForm.xb=v.id" v-for="(v, key) in lawyerDefine.sex" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.xb==v.id}]">
                <input type="radio" :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
          <div class="params-item" v-if="curType==1">
            <div class="params-item-title">执业类型：</div>
            <div class="params-item-content">
              <div @click="searchForm.zylb=''" :class="['radio-item ',{active:!searchForm.zylb}]">
                <input type="radio" value="">
                不限
              </div>
              <div @click="searchForm.zylb=v.id" v-for="(v, key) in lawyerDefine.zylb" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.zylb==v.id}]">
                <input type="radio" :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
          <div class="params-item" v-if="curType==2">
            <div class="params-item-title">组织形式：</div>
            <div class="params-item-content">
              <div @click="searchForm.zzxs=''" :class="['radio-item ',{active:!searchForm.zzxs}]">
                <input type="radio" value="">
                不限
              </div>
              <div @click="searchForm.zzxs=v.id" v-for="(v, key) in firmDefine.zzxs_data" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.zzxs==v.id}]">
                <input type="radio" :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
          <div class="params-item" v-if="curType==2">
            <div class="params-item-title">律师人数：</div>
            <div class="params-item-content">
              <div @click="searchForm.lsrs=''" :class="['radio-item ',{active:!searchForm.lsrs}]">
                <input type="radio" value="">
                不限
              </div>
              <div @click="searchForm.lsrs=1" :class="['radio-item ',{active:searchForm.lsrs==1}]">
                <input type="radio" value="">
                10人以下
              </div>
              <div @click="searchForm.lsrs=2" :class="['radio-item ',{active:searchForm.lsrs==2}]">
                <input type="radio" value="">
                10-30人
              </div>
              <div @click="searchForm.lsrs=3" :class="['radio-item ',{active:searchForm.lsrs==3}]">
                <input type="radio" value="">
                30-50人
              </div>
              <div @click="searchForm.lsrs=4" :class="['radio-item ',{active:searchForm.lsrs==4}]">
                <input type="radio" value="">
                50-100人
              </div>
              <div @click="searchForm.lsrs=5" :class="['radio-item ',{active:searchForm.lsrs==5}]">
                <input type="radio" value="">
                100人以上
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu.vue'

export default {
  components: { Menus },
  data () {
    return {
      searchForm: {
        city: '',
        code: '',
        xb: '',
        zylb: '',
        zwmc: '',
        mc: '',
        zzxs: '',
        lsrs: ''
      },
      lawyerDefine: '',
      firmDefine: ''
    }
  },
  computed: {
    arealist () {
      return this.$store.state.device.area
    },
    curType () {
      return this.$route.params.type
    }
  },
  watch: {
    searchForm: {
      deep: true,
      handler (val) {
        this.searchForm.mc = this.searchForm.mc.trim()
        this.searchForm.zwmc = this.searchForm.zwmc.trim()
      }
    },
  },
  created () {
    this.getDefine()
  },

  methods: {
    setTxtArea () {
      window.addEventListener('resize', function () {
        if (document.activeElement.tagName === 'TEXTAREA' || document.activeElement.tagName === 'INPUT') {
          document.activeElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    async getDefine () {
      const data = await this.$api.getLawyerDefine()
      this.lawyerDefine = data
      const res = await this.$api.getLawfirmDefine()
      this.firmDefine = res
    },
    getSearch () {
      let { code, xb, zylb, mc, city, zwmc, lsrs, zzxs } = this.searchForm;
      if (this.curType === '1') {
        if (!mc) {
          this.$alert('请输入律师中文名/执业证号')
        } else {
          this.$router.push(`/lawyerlist?code=${code}&xb=${xb}&zylb=${zylb}&mc=${mc}&city=${city}`);
        }
      }
      if (this.curType === '2') {
        if (!zwmc) {
          this.$alert('请输入律师事务所中文名/统一社会信用代码')
        } else {
          this.$router.push(`/firmlist?code=${code}&zzxs=${zzxs}&zwmc=${zwmc}&lsrs=${lsrs}&city=${city}`);
        }
      }

    }
  }
}
</script>
<style lang="stylus" scoped>
.page-firm-lawyer-search
  color #fff
  padding-bottom 200px
  .firm-lawyer-content
    width 70%
    margin 0 auto
    padding-top 1rem
    padding-bottom 2rem
    .tab-nav
      padding-left 0.3rem
      font-size 0.26rem
      .nav-item
        margin-right 38px
        color #ffffff
        text-decoration none
        &.active
          color #ffc419
    .input-panel
      position relative
      margin-top 0.1rem
      border-radius 0.1rem
      display flex
      background #fff
      border 1px solid #378bf8
      &.c1::before, &.c2::before
        content ''
        position absolute
        top -7px
        width 0
        height 0
        z-index 2
        border-style solid
        border-width 0 7px 7px 7px
        border-color transparent transparent #fff transparent
      &.c1::before
        left 0.4rem
      &.c2::before
        left 1.4rem
      input
        color #333
        font-size 0.22rem
        padding 0 0.2rem
        flex 1
        border-radius 0.1rem 0 0 0.1rem
        border 0
      input:-moz-placeholder, input::-moz-placeholder
        color #999
        opacity 1
      input:-ms-input-placeholder
        color #999
      input::-webkit-input-placeholder
        color #999
      button
        border-radius 0.1rem
        width 3.6rem
        height 0.72rem
        margin 0.04rem
        background-color #2a69e0
    .search-params
      padding-top 0.6rem
      .hts
        font-size 0.24rem
        letter-spacing 1px
        color #ffffff
        margin-bottom 0.4rem
      .params-item
        display flex
        margin-bottom 0.3rem
        .params-item-title
          font-size 0.22rem
          width 1.1rem
          flex-shrink 0
          text-align right
        .params-item-content
          flex 1
          display flex
          font-size 0.22rem
          flex-wrap wrap
          padding-left 0.1rem
    .radio-item
      letter-spacing 1px
      margin-bottom 0.1rem
      margin-right 0.2rem
      input
        width 12px
        height 12px
        cursor pointer
        margin-right 2px
        border-radius 2px
        border solid 1px #fff
      &.active
        color #f29530
        input
          position relative
          border-color #f29530
          &::after
            content ''
            position absolute
            top -1px
            left 1px
            width 5px
            height 8px
            border-left solid #f29530 1px
            border-top solid #f29530 1px
            transform rotate(225deg)
</style>